import styled from "styled-components";
import { Link } from "react-router-dom";

export const LinkContainer = styled(Link)`
  text-decoration: none;
`;
